export function NewsletterOptIn({ checked, onChange, testId, className = "" }) {
  return (
    <label className={`flex items-center gap-3 cursor-pointer ${className}`}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
        data-testid={testId} className="w-5 h-5 accent-[#2D2D2D]" />
      <span className="text-[#1E1E1E] text-[15px]">Also send me The Sideline, one coaching read a week. Unsubscribe anytime.</span>
    </label>
  );
}
